const setup = (moduleId) => {
	const refresh = {
		moduleId: moduleId,
		register: (type, id) => {
			const typeId = moduleId + " " + id;
			refresh.runtime.register(type, typeId);
		},
		signature: () => (refresh.runtime.createSignatureFunctionForTransform()),
		runtime: {
			createSignatureFunctionForTransform: () => ((type) => (type)),
			register: x => {}
		},
	};
	return refresh;
}

__webpack_require__.i.push((options) => {
	const originalFactory = options.factory;
	options.factory = function(moduleObject, moduleExports, webpackRequire) {
		const hotRequire = (request) => (webpackRequire(request));
		const createPropertyDescriptor = (name) => {
			return {
				configurable: true,
				enumerable: true,
				get: () => (webpackRequire[name]),
				set: (value) => {
					webpackRequire[name] = value;
				},
			};
		};
		for (const name in webpackRequire) {
			if (Object.prototype.hasOwnProperty.call(webpackRequire, name) && name !== "$Refresh$") {
				Object.defineProperty(hotRequire, name, createPropertyDescriptor(name));
			}
		}
		hotRequire.$Refresh$ = setup(options.id);
		originalFactory.call(this, moduleObject, moduleExports, hotRequire);
	};
});